import { Box, Divider as JoyDivider, Stack, styled, Typography } from '@mui/joy';

export const tableStyle = {
  height: '100%',
};

export const ActionsWrapper = styled(Box)({
  display: 'flex',
  height: '32px',
  marginBottom: '-32px',
  gap: 8,
});

export const HeaderWrapper = styled(Stack)({
  height: '100%',
  padding: '16px',
});

export const HeaderName = styled(Typography)({
  display: 'flex',
  gap: 8,
});

export const Divider = styled(JoyDivider)({
  marginLeft: 'calc(-1 * var(--ag-cell-horizontal-padding)) !important',
  marginRight: 'calc(-1 * var(--ag-cell-horizontal-padding)) !important',
});
